import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');
import { BaseReport } from './BaseReport';

export class AnalyticalLedgerReport extends BaseReport {
    _originalTypeClassName = "zERP.BO.AnalyticalLedgerReport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AnalyticalLedgerReport.translate = translateService;
}
super();
this.Accounts = [];
this.FlatData = [];
this._key = this.BaseReportKey = 0; 
}

static translate: TranslateService;
_key: any;
Accounts:any;
FlatData:any;
static setAccounts = ($this, items) => {
                if (items == null) items = [];
                if ($this.Accounts == null) $this.Accounts = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Accounts.length > 0) {
                    Domain.AnalyticalLedgerReport.removeAccounts($this, $this.Accounts[0]);
                }

                Domain.AnalyticalLedgerReport.addManyAccounts($this, copyItems);
            }
static addManyAccounts = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AnalyticalLedgerReport.addAccounts($this, items[i]);
                }
            }
static addAccounts = ($this, item) => {
                if ($this.Accounts == null) $this.Accounts = [];
                if (item == null || $this.Accounts.indexOf(item) > -1) return;
                $this.Accounts.push(item);
}
static addRangeAccounts = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AnalyticalLedgerReport.addAccounts($this, item));
            }
static removeAccounts = ($this, item) => {
                if ($this == null || $this.Accounts == null || $this.Accounts.indexOf(item) === -1) return;
                var _index = $this.Accounts.indexOf(item);
                $this.Accounts.splice(_index, 1);
}
static clearAccounts = ($this) => { $this.Accounts = null; }
static setFlatData = ($this, items) => {
                if (items == null) items = [];
                if ($this.FlatData == null) $this.FlatData = [];

                const copyItems = Common.cloneObject(items);

                while ($this.FlatData.length > 0) {
                    Domain.AnalyticalLedgerReport.removeFlatData($this, $this.FlatData[0]);
                }

                Domain.AnalyticalLedgerReport.addManyFlatData($this, copyItems);
            }
static addManyFlatData = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AnalyticalLedgerReport.addFlatData($this, items[i]);
                }
            }
static addFlatData = ($this, item) => {
                if ($this.FlatData == null) $this.FlatData = [];
                if (item == null || $this.FlatData.indexOf(item) > -1) return;
                $this.FlatData.push(item);
}
static addRangeFlatData = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AnalyticalLedgerReport.addFlatData($this, item));
            }
static removeFlatData = ($this, item) => {
                if ($this == null || $this.FlatData == null || $this.FlatData.indexOf(item) === -1) return;
                var _index = $this.FlatData.indexOf(item);
                $this.FlatData.splice(_index, 1);
}
static clearFlatData = ($this) => { $this.FlatData = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.BaseReportKey == null || $this.BaseReportKey == 0;
            }


}